/* 
* Fleet Card Compare Item - Aligning the background image wrapper */

var compareEqualizerResize = {

  init: function(compareEqualizer){
    // Init binding
    this.bindUIevents(compareEqualizer);
    this.placeBackgroundRow();
  },
  bindUIevents: function(compareEqualizer){
    compareEqualizer.on('postequalized.zf.equalizer', this.placeBackgroundRow); 
  },
  placeBackgroundRow: function(){
    let benefits = $('.wex-compare-item--benefits');
    let benefitsHeight = benefits.outerHeight(true);
    let position = benefits.position();
    $('.wex-compare-row-2-bg').css({ top: position.top, height: benefitsHeight });
  }
};

if ($('#compare-equalizer-benefits').length !== 0) {
  compareEqualizerResize.init($('#compare-equalizer-benefits'));
}